import { useState } from 'react';
import { isTruthy } from 'remeda';
import { useAmlFormContext } from 'shared/components/InvoiceActionsDropdown/AmlModal/types/types';

const TOTAL_STEPS = 5;

export function useAmlStepper() {
  const { values } = useAmlFormContext();

  const [activeStep, setActiveStep] = useState(0);
  const [idFront, setIdFront] = useState<File | null>(null);
  const [idBack, setIdBack] = useState<File | null>(null);

  const allFilled = (...fields: Array<string>) => fields.map(f => f.trim()).every(isTruthy);

  const isStep0Complete = () =>
    allFilled(values.caseName, values.companyName, values.vatNumber, values.registeredOffice);

  const isStep1Complete = () =>
    values.directors.every(d => isTruthy(d.name.trim())) &&
    (values.listedCompany || values.beneficialOwners.every(b => isTruthy(b.name.trim())));

  const isStep2Complete = () =>
    allFilled(
      values.lastName,
      values.firstName,
      values.address,
      values.mobile,
      values.email,
      values.nationalNumber,
    );

  const isStep3Complete = () =>
    allFilled(values.relationOrigin, values.serviceDescription) &&
    (values.pep !== 'true' || isTruthy(values.pepDetails.trim()));

  const isStep4Complete = () => [idFront, idBack].every(isTruthy);

  const isStepComplete = (step: number): boolean => {
    switch (step) {
      case 0:
        return isStep0Complete();
      case 1:
        return isStep1Complete();
      case 2:
        return isStep2Complete();
      case 3:
        return isStep3Complete();
      case 4:
        return isStep4Complete();
      default:
        return true;
    }
  };

  const goNextStep = () => setActiveStep(s => Math.min(s + 1, TOTAL_STEPS - 1));
  const goPrevStep = () => setActiveStep(s => Math.max(s - 1, 0));

  return {
    activeStep,
    idFront,
    idBack,
    setIdFront,
    setIdBack,
    isStepComplete,
    goNextStep,
    goPrevStep,
    TOTAL_STEPS,
  };
}
